import React from 'react';
import { useTranslation } from 'react-i18next';

import { CONFIG } from 'config';

import { AppTemplate } from './AppTemplate';
import * as Styled from './StyledAppTemplate';

export const AppTemplateMustUpdate = props => {
    const { t } = useTranslation('app');
    return (
        <AppTemplate name="AppTemplateMustUpdate">
            <Styled.Icons>
                <span className="icon fad fa-mobile" aria-hidden="true" />
                <span className="icon fad fa-mobile-android" aria-hidden="true" />
            </Styled.Icons>

            <Styled.Title>{t('AppTemplateMustUpdate.title')}</Styled.Title>
            <Styled.Descr>{t('AppTemplateMustUpdate.descr')}</Styled.Descr>

            <Styled.Buttn as="a" href={CONFIG.baseUrl}>
                <span className="text">{t('AppTemplateMustUpdate.button')}</span>
                <span className="icon far fa-long-arrow-right" aria-hidden="true" />
            </Styled.Buttn>
            {/* Remember that the user should donwload the app again */}
        </AppTemplate>
    );
};
export default AppTemplateMustUpdate;
